import { Button, Container, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import validator from 'validator';
import IndietroButton from '../../../components/IndietroButton';
import SpinnerComponent from '../../../components/SpinnerComponent';
import { updateGestioneOperativaControlliSemplificati } from '../../../utils/api/aggiornamentoGestioneOperativaApi';
import { getConsulenti } from '../../../utils/api/consulenti_api';
import { registerEsercizioWithResponsabile } from '../../../utils/api/esercizi_commerciali_api';
import { getGruppi } from '../../../utils/api/gruppi_api';
import SelezioneGruppo from '../components/SelezioneGruppo';
import ConsulenteSelector from './ConsulenteSelector';
import ControlloSemplificatoModal from './ControlloSemplificatoModal';
import FormDettagliNuovoEsercizio from './FormDettagliNuovoEsercizio';
import FormPagamento from './FormPagamento';
import GiorniChiusuraEsercizio from './GiorniChiusuraEsercizio';
import ResponsabileSicurezzaForm from './ResponsabileSicurezzaForm';
import { AUTH_TYPES } from '../../../auth/auth.options';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    paddingTop: '10px',
  },
  sectionContainer: {
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
    width: '100%',
  },
});

class NuovoEsercizioCommerciale extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      record: {
        esercizio: {
          id: null,
          nome: null,
          ragioneSociale: null,
          partitaIva: null,
          codiceAteco: null,
          telefono: null,
          nomeGestore: null,
          cognomeGestore: null,
          emailGestore: null,
          telefonoGestore: null,
          indirizzoSede: null,
          numeroSede: null,
          cittaSede: null,
          provinciaSede: null,
          codiceSdi: null,
          pec: null,
          gruppoId: null,
          gestioneOperativaSeparata: false,
          responsabileSicurezza: {
            email: '',
            password: '',
            confirmPassword: '',
            nome: '',
            cognome: '',
            telefono: '',
            terminiUsoAccettati: false,
            privacyPolicyAccettata: false,
            gruppoId: null,
            passwordEnabled: true,
            oauthEnabled: false,
          },
        },
        storicoPricingDTO: {
          moltiplicatore: 1,
          anniValidita: 1,
          valoreIva: '',
          imponibile: '',
          totaleLordo: '',
          modalita: 'BONIFICO',
          consulenteId: this.props.consulenteId,
          esercizioCommercialeId: '',
          dataAggiornamento: '',
        },
        aggiornamentoGestioneOperativaDTO: null,
        giorniChiusura: [],
      },

      validationErrors: {
        nome: '',
        ragioneSociale: '',
        emailGestore: '',
        email: '',
        password: '',
        confirmPassword: '',
        privacyPolicyAccettata: '',
        consulenteId: '',
      },
      gruppi: [],
      consulenti: [],
      costoUnitario: '',
      showPassword1: false,
      showPassword2: false,
      loading: true,
      notfoundRecord: false,
      saveButtonEnabled: false,
      disabledButtons: false,
      saveMessageVisible: false,
      isControlloSemplificatoModalVisible: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchGruppi();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchGruppi = () => {
    this.setState({
      loading: true,
    });
    getGruppi(null, null, 0, 1000, 'nome')
      .then((result) => {
        if (this._isMounted) {
          let record = this.state.record;
          let esercizio = record.esercizio;
          let gruppoId = esercizio.gruppoId;

          const defaultGruppo = result.find(
            (gruppo) => gruppo.nome === 'BS-FOOD',
          );

          if (!gruppoId && defaultGruppo) {
            gruppoId = defaultGruppo.id;
            this.setState({ costoUnitario: defaultGruppo.costoUnitario });
          }

          esercizio.gruppoId = gruppoId;
          esercizio.responsabileSicurezza.gruppoId = gruppoId;
          record.esercizio = esercizio;
          this.setState(
            {
              loading: false,
              gruppi: result,
              record,
            },
            () => {
              if (gruppoId) {
                this.fetchConsulenti(gruppoId);
              }
            },
          );
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          this.setState({
            loading: false,
          });
          reportApiError(error);
        }
      });
  };

  fetchConsulenti = (gruppoId) => {
    getConsulenti(null, gruppoId, 0, 1000, 'id')
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            consulenti: response,
          });
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          reportApiError(error);
        }
      });
  };

  updateParentState = (data) => {
    let record = this.state.record;
    record.giorniChiusura = data;
    this.setState({
      record: record,
      saveButtonEnabled: true,
    });
  };

  validateFieldResponsabileSicurezza = (key, value) => {
    const rs = this.state.record.esercizio.responsabileSicurezza;
    // se SSO, non validare password
    if (
      !rs.passwordEnabled &&
      (key === 'password' || key === 'confirmPassword')
    ) {
      const validationErrors = this.state.validationErrors;
      validationErrors.password = '';
      validationErrors.confirmPassword = '';
      this.setState({ validationErrors });
      return;
    }

    let insertedPsw =
      this.state.record.esercizio.responsabileSicurezza.password;
    let validationErrors = this.state.validationErrors;

    switch (key) {
      case 'email':
        if (value.length === 0) {
          validationErrors.email = "Inserire l'indirizzo email";
        } else {
          if (validator.isEmail(value)) {
            validationErrors.email = '';
          } else {
            validationErrors.email = "L'indirizzo email inserito non è valido";
          }
        }
        break;
      case 'password':
        validationErrors.password =
          value.length >= 8
            ? ''
            : 'Inserire una password di almeno 8 caratteri';
        break;
      case 'confirmPassword':
        if (value.length === 0) {
          validationErrors.confirmPassword = 'Ripetere la password';
        } else {
          if (value === insertedPsw) {
            validationErrors.confirmPassword = '';
          } else {
            validationErrors.confirmPassword =
              'Le due password non corrispondono';
          }
        }
        break;

      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  validateForm = () => {
    let data = this.state.record.esercizio;
    Object.keys(data).forEach((key) => {
      this.validateField(key, data[key]);
    });
    let responsabile = this.state.record.esercizio.responsabileSicurezza;
    Object.keys(responsabile).forEach((key) => {
      if (
        responsabile.passwordEnabled === false &&
        (key === 'password' || key === 'confirmPassword')
      ) {
        return;
      }
      this.validateFieldResponsabileSicurezza(key, responsabile[key]);
    });

    let validationErrors = this.state.validationErrors;

    if (!this.state.record.esercizio.consulenteId) {
      validationErrors.consulenteId = 'Selezionare un consulente';
    } else {
      validationErrors.consulenteId = '';
    }
    //Return false if there are validation errors:
    let valid = true;

    Object.values(validationErrors).forEach((val) => {
      val.length > 0 && (valid = false);
    });
    return valid;
  };

  validateField = (key, value) => {
    let validationErrors = this.state.validationErrors;
    switch (key) {
      case 'nome':
        if (value === null || value.length === 0) {
          validationErrors.nome = 'Inserire nome';
        } else {
          validationErrors.nome = '';
        }
        break;
      case 'ragioneSociale':
        if (value === null || value.length === 0) {
          validationErrors.ragioneSociale = 'Inserire ragione sociale';
        } else {
          validationErrors.ragioneSociale = '';
        }
        break;
      case 'emailGestore':
        if (value === null || value.length === 0) {
          validationErrors.emailGestore =
            'Inserire indirizzo email del titolare';
        } else {
          if (validator.isEmail(value)) {
            validationErrors.emailGestore = '';
          } else {
            validationErrors.emailGestore =
              "L'indirizzo email inserito non è valido";
          }
        }
        break;
      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    const finalValue = type === 'checkbox' ? checked : value;
    this.handleFormChange(name, finalValue);
  };

  handleChangeAbbonamento = (value, fieldName) => {
    if (!this.state.saveButtonEnabled) {
      this.setState({
        saveButtonEnabled: true,
      });
    }
    let data = this.state.record;
    data.storicoPricingDTO[fieldName] = value;
    this.setState({
      record: data,
    });
  };

  handleSelectedGruppo = (gruppoId) => {
    this.setState((prevState) => {
      const updatedRecord = { ...prevState.record };
      updatedRecord.esercizio.gruppoId = gruppoId;
      updatedRecord.esercizio.responsabileSicurezza.gruppoId = gruppoId;
      delete updatedRecord.esercizio['consulenteId'];

      const selectedGruppo = prevState.gruppi.find(
        (gruppo) => gruppo.id === gruppoId,
      );

      return {
        record: updatedRecord,
        costoUnitario: selectedGruppo ? selectedGruppo.costoUnitario : '',
        saveButtonEnabled: true,
      };
    });

    this.fetchConsulenti(gruppoId);
  };

  onItemSelected = (value) => {
    this.setState((prevState) => {
      const { consulenti, record, validationErrors } = prevState;

      const selectedConsulente = consulenti.find(
        (consulente) => consulente.id === value,
      );

      if (!selectedConsulente) {
        return null;
      }

      return {
        saveButtonEnabled: true,
        record: {
          ...record,
          esercizio: {
            ...record.esercizio,
            consulenteId: selectedConsulente.id,
          },
        },
        validationErrors: {
          ...validationErrors,
          consulenteId: '', // Rimuove l'errore
        },
      };
    });
  };

  handleChangeResponsabileSicurezza = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => {
      const record = { ...prevState.record };
      const rs = { ...record.esercizio.responsabileSicurezza };

      rs[name] = value;
      record.esercizio = { ...record.esercizio, responsabileSicurezza: rs };

      const validationErrors = { ...this.state.validationErrors };
      //Reset validation :
      if (
        name === 'email' ||
        name === 'password' ||
        name === 'confirmPassword'
      ) {
        validationErrors[name] = '';
      }

      return { record, validationErrors, saveButtonEnabled: true };
    });
  };

  handleFormChange = (fieldName, value) => {
    this.setState((prevState) => {
      const updatedRecord = { ...prevState.record };
      updatedRecord.esercizio[fieldName] = value;

      return {
        record: updatedRecord,
        saveButtonEnabled: true,
      };
    });
  };

  handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;

    this.setState((prevState) => {
      const record = { ...prevState.record };
      const rs = { ...record.esercizio.responsabileSicurezza };

      rs.passwordEnabled = isLocal;
      rs.oauthEnabled = !isLocal;

      if (!isLocal) {
        rs.password = '';
        rs.confirmPassword = '';
      }

      record.esercizio = { ...record.esercizio, responsabileSicurezza: rs };

      return {
        record,
        validationErrors: {
          ...prevState.validationErrors,
          password: '',
          confirmPassword: '',
        },
      };
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const isValid = this.validateForm();
    if (!isValid) return;

    const data = {
      ...this.state.record,
      storicoPricingDTO: {
        ...this.state.record.storicoPricingDTO,
        dataAggiornamento: null,
      },
    };

    this.setState({
      loading: true,
    });
    // Sostituito registerEsercizioAsAdmin() con chiamata consulente per adeguamento form
    registerEsercizioWithResponsabile(data)
      .then((response) => {
        this.setState((prevState) => ({
          saveButtonEnabled: false,
          disabledButtons: true,
          saveMessageVisible: true,
          record: {
            ...prevState.record,
            aggiornamentoGestioneOperativaDTO:
              response.aggiornamentoGestioneOperativaDTO,
          },

          isControlloSemplificatoModalVisible:
            response.esercizio.gestioneOperativaSeparata &&
            !!response.aggiornamentoGestioneOperativaDTO,
        }));
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleClickShowPassword = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  onCloseControlloSemplificatoModal = () => {
    this.setState({
      isControlloSemplificatoModalVisible: false,
    });
  };

  onUpdateModalitaGestioneControlli = (isSemplificata) => {
    const { aggiornamentoGestioneOperativaDTO } = this.state.record;

    if (aggiornamentoGestioneOperativaDTO?.id == null) {
      return;
    }

    const id = aggiornamentoGestioneOperativaDTO.id;

    updateGestioneOperativaControlliSemplificati(id, isSemplificata)
      .then(() => {
        this.setState({
          isControlloSemplificatoModalVisible: false,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  render() {
    const { classes } = this.props;
    Moment.locale('it-IT');
    const disabledSubmitbutton =
      this.state.loading ||
      !this.state.saveButtonEnabled ||
      this.state.saveMessageVisible;

    let textFieldsDisabled = this.state.saveMessageVisible;

    return (
      <div className={classes.mainContainer}>
        <Typography variant="h4">Nuovo esercizio commerciale</Typography>
        <Grid
          container
          justify="center"
          style={{
            marginTop: '26px',
            marginBottom: '26px',
          }}
        >
          <div style={{ minHeight: '500px' }}>
            {this.state.loading ? (
              <SpinnerComponent size={24} />
            ) : (
              <form autoComplete="off" onSubmit={this.handleSubmit}>
                <Grid container justify="center" alignItems="center">
                  <Container style={{ padding: '10px 0' }}>
                    <FormDettagliNuovoEsercizio
                      handleChange={this.handleChange}
                      record={this.state.record}
                      textFieldsDisabled={textFieldsDisabled}
                      validationErrors={this.state.validationErrors}
                    />
                  </Container>
                </Grid>
                <Container className={classes.sectionContainer}>
                  <Typography variant="h6">Dati gruppo</Typography>
                  <SelezioneGruppo
                    gruppoId={this.state.record.esercizio.gruppoId}
                    gruppi={this.state.gruppi}
                    disabled={textFieldsDisabled}
                    description="Scegliere il gruppo di appartenenza del nuovo esercizio commerciale."
                    onGruppoSelected={this.handleSelectedGruppo}
                  />
                </Container>
                <Grid container justify="center" alignItems="center">
                  <Container style={{ padding: '10px 0' }}>
                    <ConsulenteSelector
                      consulenti={this.state.consulenti}
                      onItemSelected={this.onItemSelected}
                      record={this.state.record}
                      textFieldsDisabled={textFieldsDisabled}
                      errorMessage={this.state.validationErrors.consulenteId}
                    />
                  </Container>
                  <Container style={{ padding: '10px 0' }}>
                    <ResponsabileSicurezzaForm
                      record={this.state.record}
                      handleAuthTypeChange={this.handleAuthTypeChange}
                      handleChangeResponsabileSicurezza={
                        this.handleChangeResponsabileSicurezza
                      }
                      handleClickShowPassword={this.handleClickShowPassword}
                      showPassword1={this.state.showPassword1}
                      showPassword2={this.state.showPassword2}
                      textFieldsDisabled={textFieldsDisabled}
                      validationErrors={this.state.validationErrors}
                    />
                  </Container>
                </Grid>
                <Container style={{ padding: '10px 0' }}>
                  <FormPagamento
                    costoUnitario={this.state.costoUnitario}
                    abbonamentoData={this.state.record.storicoPricingDTO}
                    handleChangeAbbonamento={this.handleChangeAbbonamento}
                    textFieldsDisabled={textFieldsDisabled}
                  />
                </Container>
                <GiorniChiusuraEsercizio
                  esercizioId={this.state.record.esercizio.id}
                  giorniChiusura={this.state.record.giorniChiusura}
                  updateParentState={this.updateParentState}
                  disabledButtons={this.state.disabledButtons}
                  updateGiorniChiusura={this.updateParentState}
                  theme={this.props.theme}
                />
                <Grid container justify="center" style={{ paddingTop: '10px' }}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ textAlign: 'center' }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: this.state.saveMessageVisible ? 'green' : 'red',
                        visibility:
                          this.state.saveMessageVisible ||
                          Object.values(this.state.validationErrors).some(
                            (err) => err.length > 0,
                          )
                            ? 'inherit'
                            : 'hidden',
                      }}
                    >
                      {this.state.saveMessageVisible
                        ? 'Nuovo esercizio commerciale registrato con successo'
                        : 'Compilare tutti i campi obbligatori evidenziati'}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ textAlign: 'right' }}
                  >
                    <IndietroButton isDisabled={this.state.loading} />
                    <Button
                      type="submit"
                      onClick={this.handleSubmit}
                      variant="contained"
                      size="medium"
                      disabled={disabledSubmitbutton}
                      style={{
                        color: disabledSubmitbutton
                          ? this.props.theme.palette.text.disabled
                          : this.props.theme.palette.text.main,
                        margin: '10px',
                        backgroundColor: disabledSubmitbutton
                          ? this.props.theme.palette.disabled.main
                          : this.props.theme.palette.primary.main,
                      }}
                    >
                      Salva
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </div>
        </Grid>
        {this.state.isControlloSemplificatoModalVisible && (
          <ControlloSemplificatoModal
            open={this.state.isControlloSemplificatoModalVisible}
            onClose={this.onCloseControlloSemplificatoModal}
            updateModalita={this.onUpdateModalitaGestioneControlli}
          />
        )}
      </div>
    );
  }
}

NuovoEsercizioCommerciale.propTypes = {
  consulenteId: PropTypes.number,
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NuovoEsercizioCommerciale);
